import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import useScrollToHash from '@hooks/useScrollToHash';
import { event_path } from '@routes';
import { ClickTarget, click } from '@tracking';
import { Event } from '@utils/backend-api/events';

import FutureEventCard from './FutureEventCard';

interface FutureEventsProps {
  futureEvents: Event[];
}

const FutureEvents = ({ futureEvents }: FutureEventsProps) => {
  const { trackEvent } = useEventTracking();
  const futureEventsRef = useScrollToHash({ hash: 'upcoming-section', offset: 100 });
  return (
    <div className="px-12" id="upcoming-section" ref={futureEventsRef}>
      <div className="m-auto max-w-container-lg">
        <h3 className="border-0 border-b border-solid border-grayscale-beige pb-32 font-suisse-screen text-headline-lg">
          Upcoming
        </h3>
        <div className="flex flex-col">
          {futureEvents.map((event) => (
            <div
              key={event.slug}
              className="cursor-pointer border-0 border-b border-solid border-grayscale-beige pb-64 pt-64 first:pt-0 last:border-b-0"
              onClick={(e) => {
                if ((e.target as HTMLElement).closest('a, button')) return;
                window.location.href = event_path(event.slug);
              }}
              onClickCapture={() =>
                trackEvent(click({ clickTarget: ClickTarget.FutureEvent, clickText: event.name }))
              }
            >
              <FutureEventCard event={event} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FutureEvents;
